import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { TextboxType } from "../textbox/textbox-type.enum";
import { TextBoxWithButtonComponent } from "./textbox-with-button.component";

export interface ITextBoxWithButtonOptions extends IDynamicInputOptions {
  type?: TextboxType;
  dataType?: string;
  placeholder?: string;
  autocomplete?: string;
  title?: string;
  classOverride?: string;
  maxlength?: number;
  tooltip?: string;
  pageNumber?: number;
  labelPosition?: string;
  labelWhenInputIsDisabled?: string;
  buttonText?: string;
  onClick?(value: any): void;  // Add this line to include the onClick handler
}

export class TextBoxWithButton extends DynamicInput implements ITextBoxWithButtonOptions {
  type: TextboxType;
  dataType: string;
  placeholder: string;
  autocomplete: string;
  title: string;
  classOverride: string;
  maxlength?: number;
  tooltip: string;
  pageNumber?: number;
  labelPosition?: string;
  labelWhenInputIsDisabled?: string;
  buttonText?: string;
  readonly controlType = "textbox";
  readonly componentType = TextBoxWithButtonComponent;

  constructor(options: ITextBoxWithButtonOptions = {}) {
    super(options);
    this.type = options.type || TextboxType.TEXT;
    this.dataType = options.dataType || "";
    this.placeholder = options.placeholder || "";
    this.autocomplete = options.autocomplete || "off";
    this.title = options.title || "";
    this.classOverride = options.classOverride || "";
    this.maxlength = options.maxlength;
    this.tooltip = options.tooltip;
    this.pageNumber = options.pageNumber;
    this.labelPosition = options.labelPosition;
    this.labelWhenInputIsDisabled = options.labelWhenInputIsDisabled;
    this.buttonText = options.buttonText || "";
  }
}
